import {
  BaseEntityDropdownProps,
  EntityDropdownInput,
} from "#batteries-included-components/Dropdowns/EntityDropdownInput";
import useLocalization from "#src/hooks/useLocalization";
import { DeviceAdapter } from "@validereinc/domain";
import React from "react";

export const DeviceDropdownInput = ({
  name = "device.id",
  label,
  ...props
}: BaseEntityDropdownProps) => {
  const { localize } = useLocalization();

  return (
    <EntityDropdownInput
      fetchEntityList={DeviceAdapter.getList}
      label={label ?? localize("Device")}
      name={name}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      {...props}
    />
  );
};
